// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--1nXtN3-81","changed":"changed--3XP4QWtAY"};